module.exports = __webpack_public_path__ + "img/ch15_06_巡查问答.0def54ef.jpg";